export const ROUTE_PERMISSIONS = [
    // { path: "/community/learning-coach-community", roles: ["LEARNING_COACH"] },
    { path: "/community/k12-zone", roles: [ "LEARNING_COACH", "STUDENT"]  },
    // { path: "/k12-checklist-category/learning-coach-life/", roles: [ "LEARNING_COACH"]  },
    // { path: "/k12-checklist/what-is-a-learning-coach", roles: [ "LEARNING_COACH"]  },
    // { path: "/k12-checklist/what-does-a-learning-coach-do", roles: [ "LEARNING_COACH"]  },
    
//   { path: "/learning-materials", roles: [ "learning_coach"] },
//   { path: "/contact", roles: [ "learning_coach", "student"] },
//   { path: "/school-prep-checklist", roles: [ "learning_coach", "student"] },
//   { path: "/k12-checklist-category/forms-and-documents/", roles: ["LEARNING_COACH"] },
//   { path: "/community", roles: [ "LEARNING_COACH", "STUDENT"] },

//   { path: "/k12-checklist/school-start-faqs/", roles: ["student"] }
];
